<template>
  <div class="mt-4">
    <h2 class="h5 ml-4 mt-4 mb-2" v-if="order.homeOrder">Home Order</h2>
    <div class="list-group mb-3" v-if="order.homeOrder">
      <router-link
        :to="`/orders/${order.id}/pack/homeOrder`"
        class="list-group-item list-group-item-action d-flex justify-content-between"
        :class="{ 'list-group-item-success': order.homeOrder.shoppingList.completed }"
      >
        🏚 Home Order
      </router-link>
    </div>

    <h2 class="h5 ml-4 mt-4 mb-2" v-if="order.kioskOrder">Kiosk Order</h2>
    <div class="list-group mb-3" v-if="order.kioskOrder">
      <router-link
        :to="`/orders/${order.id}/pack/kioskOrder`"
        class="list-group-item list-group-item-action d-flex justify-content-between"
        :class="{ 'list-group-item-success': order.kioskOrder.completed }"
      >
        🏪 Kiosk Order
      </router-link>
    </div>

    <div v-if="order.residents">
      <h2 class="h5 ml-4 mt-4 mb-2">Residents</h2>
      <div class="list-group">
        <router-link
          v-for="(resident, i) in order.residents"
          :key="i"
          :to="`/orders/${order.id}/pack/resident/${i}`"
          class="list-group-item list-group-item-action d-flex justify-content-between"
          :class="{ 'list-group-item-success': resident.shoppingList.completed }"
        >
          <span>{{ i + 1 }}. {{ formatResidentName({ resident }) }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    order() {
      return this.$store.state.orders.find(o => o.id === this.$route.params.orderId)
    },
    residents() {
      const { residents } = this.order
      if (typeof residents === 'undefined') return null
      return residents
    }
  }
}
</script>
